import React, { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';

/* ── Sticky mobile CTA — Phase 99A light direction ──────────────────
 * Appears only on viewports <= md breakpoint once the user has
 * scrolled past the hero (avoids obscuring above-the-fold content).
 * Now paper-toned to match the rest of the public site.
 */
export const StickyMobileCTA = ({ label, onClick, testid = 'sticky-mobile-cta' }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const threshold = Math.max(window.innerHeight * 0.3, 260);
      setVisible(window.scrollY > threshold);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={
        'md:hidden fixed inset-x-0 bottom-0 z-40 px-4 pb-4 pt-3 pointer-events-none ' +
        (visible ? 'sticky-cta--visible' : 'sticky-cta--hidden')
      }
      data-testid={`${testid}-wrap`}
      aria-hidden={!visible} inert={!visible}
    >
      <div
        className="pointer-events-auto rounded-xl px-3 py-2.5 flex items-center gap-3"
        style={{
          background: 'rgba(246,244,239,0.96)',
          backdropFilter: 'saturate(180%) blur(10px)',
          WebkitBackdropFilter: 'saturate(180%) blur(10px)',
          border: '1px solid var(--gpc-line)',
          boxShadow: '0 12px 32px -16px rgba(19,35,63,0.25)',
        }}
      >
        <p style={{ fontFamily: 'Inter, system-ui, sans-serif', fontSize: '11px', color: 'var(--gpc-ink-soft)', flex: 1, lineHeight: 1.3 }}>
          Speak with GP Capital about your mandate.
        </p>
        <button
          type="button"
          className="gpc-cta-primary shrink-0"
          style={{ height: '2rem', padding: '0 0.9rem', fontSize: '0.8125rem' }}
          onClick={onClick}
          data-testid={testid}
        >
          {label} <ArrowRight className="w-3.5 h-3.5" />
        </button>
      </div>
      <style>{`
        .sticky-cta--visible { opacity: 1; transform: translateY(0); transition: opacity 0.3s ease, transform 0.3s ease; }
        .sticky-cta--hidden  { opacity: 0; transform: translateY(16px); transition: opacity 0.3s ease, transform 0.3s ease; }
      `}</style>
    </div>
  );
};

export default StickyMobileCTA;
